const DEFAULT_OPERATION_SEQUENCE = 9999;

export const getOperationSequence = (operation) => {
  const sequence = Number(operation?.Sequence);
  return Number.isFinite(sequence) && sequence > 0 ? sequence : DEFAULT_OPERATION_SEQUENCE;
};

export const getOperationSortLabel = (operation) =>
  String(operation?.DisplayName || operation?.Text || operation?.Name || operation?.OperationTypeId || operation?.Value || operation?._id || "");

export const getOperationSortId = (operation) =>
  String(operation?.OperationTypeId || operation?.Name || operation?.Value || operation?._id || operation?.Id || "");

export const compareOperations = (a, b) => {
  const sequenceA = getOperationSequence(a);
  const sequenceB = getOperationSequence(b);
  if (sequenceA !== sequenceB) return sequenceA - sequenceB;

  const labelCompare = getOperationSortLabel(a).localeCompare(getOperationSortLabel(b));
  if (labelCompare !== 0) return labelCompare;

  return getOperationSortId(a).localeCompare(getOperationSortId(b));
};

export const sortOperations = (operations) =>
  Array.isArray(operations) ? [...operations].sort(compareOperations) : [];
